export default __webpack_public_path__ + "static/media/fruit.3c736262.svg";